<template>
  <div class="home">
    <h1>Welcome, {{ user ? user.fullName : 'Guest' }}</h1>
    <p>This is a protected home page.</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['getUser']),
    user() {
      return this.getUser;
    }
  }
};
</script>

<style scoped>
.home {
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
}
</style>
